import { render, staticRenderFns } from "./PartinerList.vue?vue&type=template&id=f0f3c1ec&"
import script from "./PartinerList.vue?vue&type=script&lang=js&"
export * from "./PartinerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports